
import "/app/src/components/Layout/SiderResizeHandle.module.less?modules";
export default {"dragMask": `dragMask-sxqeAALv`,"boundary": `boundary-bJiB90RM`,"dark": `dark-LZiwJkvW`,"hitBox": `hitBox-XAPFCGKj`}
